import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  assignInfluencerToCampaignApi,
  getCampaignByIdApi,
  updateCampaignByIdApi,
} from '@src/api/campaigns';
import { getInfluencerListApi } from '@src/api/influencers';
import type { InfluencerParams } from '@src/api/influencers/index.d';
import { UpdateCampaignData } from '@src/types/campaign';
import { AssignInfluencerData } from '@src/types/influencer';

export const getCampaignThunk = createAsyncThunk(
  'getCampaign',
  async (campaignId: string | number, { rejectWithValue }) => {
    try {
      const response = await getCampaignByIdApi(campaignId);

      return response.result?.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const updateCampaignThunk = createAsyncThunk(
  'updateCampaign',
  async (updateData: UpdateCampaignData, { rejectWithValue }) => {
    try {
      const response = await updateCampaignByIdApi(updateData);

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const assignInfluencerToCampaignThunk = createAsyncThunk(
  'assignInfluencer',
  async (data: AssignInfluencerData, { rejectWithValue }) => {
    try {
      const response = await assignInfluencerToCampaignApi(data);

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const getCampaignInfluencerListThunk = createAsyncThunk(
  'getCampaignInfluencer',
  async (params: InfluencerParams, { rejectWithValue }) => {
    try {
      const response = await getInfluencerListApi(params);

      return response.result?.data.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
